import { Grid } from '@mui/joy'
import AppCard from '../../../components/module/AppCard/AppCard'
import { AndroidLogoIcon, AppleLogoIcon } from '@phosphor-icons/react'
import { AppProfile } from '../../../components/app/App'
import LayoutSettings from '../../../components/layout/LayoutSettings'
import { useAppVersion } from '../../../hooks/app/useAppVersion'

export default function PageApps() {
    const domain = window.location.origin;
    const { data, loading, error } = useAppVersion();

    const apps = {
        ios: `${domain}/download/ios`,
        android: `${domain}/download/android`,
        googleplay: `https://play.google.com/store/apps/details?id=aquarium.app`,
        mac: `${domain}/download/macos`,
        windows: `${domain}/download/windows`,
        web: `${domain}`,
    }

    return (
        <AppProfile
            title="Мобильные приложения"
            desc="Мобильные приложения мессенджера Аквариум"
        >
            <LayoutSettings header="Приложения" showBack={false}>
                <Grid container spacing={3}>

                    <Grid xs={12} sm={12}>
                        <AppCard
                            title="iOS"
                            link={apps.ios}
                            linkQr={apps.ios}
                            icon={<AppleLogoIcon size={32} weight='fill' />}
                            loading={loading}
                            error={error}
                            data={data?.ios}
                        />
                    </Grid>
                    <Grid xs={12} sm={12}>
                        <AppCard
                            title="Android"
                            // link={apps.android}
                            link={apps.googleplay}
                            linkQr={apps.googleplay}
                            target="_self"
                            icon={<AndroidLogoIcon size={32} weight='fill' />}
                            moreLink={{
                                title: 'Прямая ссылка',
                                href: apps.android,
                            }}
                            loading={loading}
                            error={error}
                            data={data?.android}
                        />
                    </Grid>

                    {/* <Grid xs={12} sm={6}>
                        <AppCard title="macOS" link={apps.mac} />
                    </Grid>
                    <Grid xs={12} sm={6}>
                        <AppCard title="Windows" link={apps.windows} />
                    </Grid> */}

                </Grid>
            </LayoutSettings>
        </AppProfile>
    )
}
